import { defineComponent as _defineComponent } from 'vue';
import { vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = { class: "modal-dialog modal-dialog-centered" };
var _hoisted_2 = { class: "modal-content" };
var _hoisted_3 = { class: "modal-body d-flex flex-column align-items-center" };
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = {
    key: 0,
    class: "fw-bold"
};
var _hoisted_6 = {
    key: 0,
    class: "modal-footer two_btn d-flex"
};
var _hoisted_7 = {
    key: 1,
    class: "modal-footer"
};
import { ref, computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AlertModal',
    props: {
        locales: Object,
        visible: Boolean,
        modalIcon: String,
        modalTitle: String,
        modalText: String,
        modalText2: String,
        modalBtn: String,
        twoBtn: Boolean,
        modalBtnLeft: String,
        modalBtnRight: String,
        btnColor: String,
    },
    emits: ['left-click', 'right-click', 'close'],
    setup: function (__props, _a) {
        var __expose = _a.expose, __emit = _a.emit;
        var props = __props;
        var visible = ref(false);
        var emit = __emit;
        var onLeftClick = function () { return emit('left-click'); };
        var onRightClick = function () { return emit('right-click'); };
        var onSingleClick = function () { return emit('close'); };
        var convertedText = computed(function () {
            var _a;
            return ((_a = props.modalText) !== null && _a !== void 0 ? _a : '').replace(/\n/g, '<br>');
        });
        var showModal = function () {
            var _a;
            visible.value = true;
            var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = "".concat(scrollbarWidth, "px");
            (_a = document.querySelector('.content_wrap')) === null || _a === void 0 ? void 0 : _a.classList.add('z-index-auto');
        };
        var closeModal = function () {
            var _a;
            visible.value = false;
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            (_a = document.querySelector('.content_wrap')) === null || _a === void 0 ? void 0 : _a.classList.remove('z-index-auto');
        };
        __expose({
            showModal: showModal,
            closeModal: closeModal
        });
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e;
            return (visible.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal modal-defalut fade show d-block",
                    tabindex: "-1",
                    "aria-modal": "true",
                    role: "dialog",
                    onClick: _withModifiers(closeModal, ["self"])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _withDirectives(_createElementVNode("div", {
                                    class: "modal_icon",
                                    style: _normalizeStyle("background-image: url(/images/icons/".concat(__props.modalIcon, ".svg)"))
                                }, null, 4), [
                                    [_vShow, __props.modalIcon]
                                ]),
                                _createElementVNode("h5", null, _toDisplayString(__props.modalTitle || ((_a = __props.locales) === null || _a === void 0 ? void 0 : _a.common_noti)), 1),
                                _createElementVNode("p", {
                                    innerHTML: convertedText.value || ((_b = __props.locales) === null || _b === void 0 ? void 0 : _b.common_none)
                                }, null, 8, _hoisted_4),
                                (__props.modalText2)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.modalText2), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            (__props.twoBtn)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "white_btn",
                                        onClick: onLeftClick
                                    }, _toDisplayString(__props.modalBtnLeft || ((_c = __props.locales) === null || _c === void 0 ? void 0 : _c.service.common_close)), 1),
                                    _createElementVNode("button", {
                                        class: _normalizeClass("".concat(__props.btnColor || 'white', "_btn")),
                                        onClick: onRightClick
                                    }, _toDisplayString(__props.modalBtnRight || ((_d = __props.locales) === null || _d === void 0 ? void 0 : _d.service.common_confirm)), 3)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "blue_btn",
                                        onClick: onSingleClick
                                    }, _toDisplayString(__props.modalBtn || ((_e = __props.locales) === null || _e === void 0 ? void 0 : _e.common_confirm)), 1)
                                ]))
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
